<div class="sideNavHeaderTop">
	<div class="userCardCon">
		<div class="userButton">
			@if (hasLicenseModule(Modules.UserManagment)) {
				<mat-icon
					fontIcon="fa-user"
					fontSet="fad"
				/>
			}

			@if (!hasLicenseModule(Modules.UserManagment) && clientProperties().isRecorder) {
				<mat-icon
					fontIcon="fa-record-vinyl"
					fontSet="fad"
				/>
			}

			@if (!hasLicenseModule(Modules.UserManagment) && !clientProperties().isRecorder && clientProperties().isTablet) {
				<mat-icon
					fontIcon="fa-tablet"
					fontSet="fad"
				/>
			}
		</div>

		<button
			(click)="openUserCard.emit()"
			mat-button
			class="userCardMoreInfoBtn"
		>
			{{ T.USER_CARD_CON_MORE_INFO_BTN_TXT | translate }}
		</button>
	</div>

	@if (user()) {
		<div class="userInformationCon">
			<div class="nameCon">
				@if (hasLicenseModule(Modules.UserManagment)) {
					<div class="firstName showDotsOnOverflow">
						{{ user().firstname }}
					</div>

					<div class="lastName showDotsOnOverflow">
						{{ user().lastname }}
					</div>
				}

				@if (!hasLicenseModule(Modules.UserManagment) && clientProperties().isRecorder) {
					<div class="firstName showDotsOnOverflow">{{ T.GLOBAL_TXT_SIMSTATION | translate }}</div>
				}

				@if (!hasLicenseModule(Modules.UserManagment) && !clientProperties().isRecorder && clientProperties().isTablet) {
					<div class="firstName showDotsOnOverflow">{{ T.GLOBAL_TXT_SIMSTATION | translate }}</div>
				}
			</div>

			<div class="roleCon">
				@if (hasLicenseModule(Modules.UserManagment)) {
					@for (userRole of user().roleIds; track userRole) {
						<span>
							{{ userRole }}
						</span>
					}
				}

				@if (!hasLicenseModule(Modules.UserManagment) && clientProperties().isRecorder) {
					<span>
						{{ T.APP_COMPONENT_CONTROL_UNIT | translate }}
					</span>
				}

				@if (!hasLicenseModule(Modules.UserManagment) && !clientProperties().isRecorder && clientProperties().isTablet) {
					<span>
						{{ T.APP_COMPONENT_REMOTE_TABLET | translate }}
					</span>
				}
			</div>

			<div class="emailCon">
				{{ user().email }}
			</div>
		</div>
	}
</div>
